var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unit-settings-table__new-row" },
    [
      _c("CompassButton", {
        attrs: {
          label: _vm.$t.__("settings.units.unit_list.new_button"),
          leftIcon: "plus",
          type: "tertiary"
        },
        on: { click: _vm.addUnit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }